
/**
 * Gets the Supabase API key from environment variables
 * @returns The Supabase API key or an empty string if not set
 */
export function getSupabaseKey(): string {
  // Ensure we always return the exact correct key string without any whitespace or formatting issues
  return "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd3cWNiZGVra3hhaHlvdGVncHJwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMyMTg5NzksImV4cCI6MjA1ODc5NDk3OX0.4Rxwp3f_MVoroaYmqS4Vovw71hJ5sWrCkS3cwXtGndg";
}

/**
 * Gets the OpenAI API key from environment variables
 * @returns The OpenAI API key or an empty string if not set
 */
export function getOpenAIKey(): string {
  return process.env.OPENAI_API_KEY || '';
}
